export const ETB_SHOW_RESET = "ETB_SHOW_RESET";
export const ETB_SHOW_SET_ERROR = "ETB_SHOW_SET_ERROR";
export const ETB_SHOW_SET_RETRIEVED = "ETB_SHOW_SET_RETRIEVED";
export const ETB_SHOW_TOGGLE_LOADING = "ETB_SHOW_TOGGLE_LOADING";
